import { render } from "./BlogDetailsLeftSidebar.vue?vue&type=template&id=a0544b4c"
import script from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=js"
export * from "./BlogDetailsLeftSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__